import { ComposerClientMenu } from './ComposerClientMenu';
import type { IComposerControlsConfig } from './types';

interface ComposerClientStripProps {
  composerControls: IComposerControlsConfig | undefined;
}

/** The strip directly above the composer that holds the client picker. Renders nothing without
 * one, so the composer sits where it always has. */
export const ComposerClientStrip = ({
  composerControls,
}: ComposerClientStripProps) => {
  if (!composerControls?.clientPicker) return null;

  return (
    <div className="flex items-center px-lg py-sm">
      <ComposerClientMenu clientPicker={composerControls.clientPicker} />
    </div>
  );
};
